"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7721],{

/***/ 13704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEventListener; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Adds event listener to a given element.
 *
 * @param {HTMLElement} element Element to attach the listener to
 * @param {string} type Event type
 * @param {Function} listener Event listener
 */

function useEventListener(element, type, listener) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!element) {
      return undefined;
    }

    element.addEventListener(type, listener);
    return function () {
      element.removeEventListener(type, listener);
    };
  }, [element, type, listener]);
}

/***/ }),

/***/ 51215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useToggle; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Returns a flag and a function to toggle it.
 *
 * @param {Boolean} defaultValue Default value
 */

function useToggle(defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValue),
      value = _useState[0],
      setValue = _useState[1];

  var toggleValue = function toggleValue() {
    return setValue(function (prevValue) {
      return !prevValue;
    });
  };

  return [value, toggleValue];
}

/***/ }),

/***/ 1668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Paper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);





var Paper = function(param) {
    var arrowClassName = param.arrowClassName, _arrowPlacement = param.arrowPlacement, arrowPlacement = _arrowPlacement === void 0 ? "top" : _arrowPlacement, borderRadius = param.borderRadius, children = param.children, className = param.className, _elevation = param.elevation, elevation = _elevation === void 0 ? 0 : _elevation, _showArrow = param.showArrow, showArrow = _showArrow === void 0 ? false : _showArrow, _showBorder = param.showBorder, showBorder = _showBorder === void 0 ? true : _showBorder, _semanticElement = param.semanticElement, semanticElement = _semanticElement === void 0 ? "div" : _semanticElement, _focusedChartNode = param.focusedChartNode, focusedChartNode = _focusedChartNode === void 0 ? null : _focusedChartNode;
    var SemanticElementToRender = semanticElement;
    var parentChartFocused = focusedChartNode && document.activeElement.isEqualNode(focusedChartNode);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SemanticElementToRender, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("Paper", "Paper__elevation--".concat(elevation), borderRadius && "Paper__borderRadius--".concat(borderRadius), showBorder && "Paper--withBorder", className)
    }, parentChartFocused ? {
        role: "status",
        "aria-live": "assertive"
    } : {}), {
        children: [
            showArrow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("Paper__arrow", "Paper__arrow--".concat(arrowPlacement), arrowClassName)
            }),
            children
        ]
    }));
};
Paper.propTypes = {
    arrowClassName: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.string,
    arrowPlacement: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.oneOf([
        "top",
        "bottom",
        "left",
        "right",
        "top-right"
    ]),
    borderRadius: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.oneOf([
        "xs",
        "sm",
        "md",
        "lg"
    ]),
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.node,
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.string,
    elevation: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.oneOf([
        1,
        2
    ]),
    showArrow: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.bool,
    showBorder: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.bool
};


/***/ }),

/***/ 77721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DevTools": function() { return /* binding */ DevTools; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@wojtekmaj/react-hooks/dist/esm/useToggle.js
var useToggle = __webpack_require__(51215);
// EXTERNAL MODULE: ./node_modules/@wojtekmaj/react-hooks/dist/esm/useEventListener.js
var useEventListener = __webpack_require__(13704);
// EXTERNAL MODULE: ./src/config/appConfig.js
var appConfig = __webpack_require__(84762);
// EXTERNAL MODULE: ./src/platform/components/formComponents/index.js + 2 modules
var formComponents = __webpack_require__(10005);
// EXTERNAL MODULE: ./src/platform/components/buttons/Button.jsx
var Button = __webpack_require__(57);
// EXTERNAL MODULE: ./src/api/api.js
var api = __webpack_require__(84557);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/platform/components/Paper/Paper.jsx
var Paper = __webpack_require__(1668);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/platform/layout/DevToolsSelect.jsx





var DevToolsSelect = function(param) {
    var label = param.label, lsValueName = param.lsValueName, _trueLabel = param.trueLabel, trueLabel = _trueLabel === void 0 ? "Show" : _trueLabel, _falseLabel = param.falseLabel, falseLabel = _falseLabel === void 0 ? "Hide" : _falseLabel;
    var ref = (0,react.useState)("false"), selectValue = ref[0], setSelectValue = ref[1];
    var defaultValue = window.localStorage.getItem(lsValueName) || false;
    var onSelectChange = function(value, key) {
        localStorage.setItem(key, value);
        setSelectValue(value);
    };
    (0,react.useEffect)(function() {
        setSelectValue(defaultValue);
    }, [
        lsValueName
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formComponents/* Select */.Ph, {
        label: label,
        size: "sm",
        defaultValue: defaultValue,
        onChange: function(event) {
            return onSelectChange(event.target.value, lsValueName);
        },
        inputClassName: selectValue === "true" ? "DevTools__paper__item--true" : "DevTools__paper__item--false",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: "false",
                children: falseLabel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: "true",
                children: trueLabel
            })
        ]
    });
};
DevToolsSelect.propTypes = {
    falseLabel: (prop_types_default()).string,
    label: (prop_types_default()).string,
    lsValueName: (prop_types_default()).string,
    trueLabel: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/platform/layout/DevTools.jsx













var DevToolsComponent = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(), 2), showDevTools = ref[0], toggleShowDevTools = ref[1];
    var onDevtoolsShortcutPress = (0,react.useCallback)(function(event) {
        if (event.ctrlKey && event.key === appConfig/* appConfig.DEVTOOLS_SHORTCUT_KEY */.eG.DEVTOOLS_SHORTCUT_KEY || event.ctrlKey && event.code === "Key".concat(appConfig/* appConfig.DEVTOOLS_SHORTCUT_KEY.toUpperCase */.eG.DEVTOOLS_SHORTCUT_KEY.toUpperCase())) {
            toggleShowDevTools();
        }
    }, []);
    (0,useEventListener/* default */.Z)(document, "keypress", onDevtoolsShortcutPress);
    var onLocalDemystConsoleApiUrlChange = function(apiAddress) {
        (0,api/* setDemystConsoleApiUrl */.Eb)(apiAddress);
    };
    var onLocalBlackfinApiUrlChange = function(apiAddress) {
        (0,api/* setBlackfinApiUrl */.vG)(apiAddress);
    };
    // const onLocalVariantChange = (cookieName, variant) => {
    //   window.localStorage.setItem(cookieName, variant);
    //   document.cookie = `${cookieName}=${variant}`;
    // };
    var reloadPage = function() {
        window.location.reload(false);
    };
    if (!showDevTools) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "DevTools",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* Paper */.X, {
            className: "DevTools__paper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "DevTools__paper__table",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "DevTools__paper__column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "DevTools__paper__column__title",
                                    children: "Environment Settings"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formComponents/* Select */.Ph, {
                                    label: "Demyst Console API URL",
                                    size: "sm",
                                    defaultValue: appConfig/* appConfig.DEMYST_CONSOLE_API_URL */.eG.DEMYST_CONSOLE_API_URL,
                                    onChange: function(event) {
                                        return onLocalDemystConsoleApiUrlChange(event.target.value);
                                    },
                                    children: Object.keys(appConfig/* demystConsoleApiUrls */.Vd).map(function(envName) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: appConfig/* demystConsoleApiUrls */.Vd[envName],
                                            children: envName
                                        }, envName);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formComponents/* Select */.Ph, {
                                    label: "Blackfin API URL",
                                    size: "sm",
                                    defaultValue: appConfig/* appConfig.BLACKFIN_API_URL */.eG.BLACKFIN_API_URL,
                                    onChange: function(event) {
                                        return onLocalBlackfinApiUrlChange(event.target.value);
                                    },
                                    children: Object.keys(appConfig/* blackfinApiUrls */.t0).map(function(envName) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: appConfig/* blackfinApiUrls */.t0[envName],
                                            children: envName
                                        }, envName);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "DevTools__paper__column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "DevTools__paper__column__title",
                                    children: "Nav Pages"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Projects",
                                    lsValueName: "projects_visible"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Internal Data",
                                    lsValueName: "internal_data_visible"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Reports Monitor",
                                    lsValueName: "reports_monitor"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "New Homepage",
                                    lsValueName: "new_homepage"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Table Provider Exports",
                                    lsValueName: "table_provider_exports"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Table Provider Imports",
                                    lsValueName: "table_provider_imports"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "DevTools__paper__column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "DevTools__paper__column__title",
                                    children: "Features"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "User Tracking in Browser Console",
                                    lsValueName: "user_tracking_visible"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Checklist on Admin",
                                    lsValueName: "checklist"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Contracts on Billing",
                                    lsValueName: "contracts_on_billing_visible"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Attributes",
                                    lsValueName: "attributes"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Global Catalog Statistics",
                                    lsValueName: "global_catalog_statistics"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Data Utilization Sans Graphs",
                                    lsValueName: "data_utilization_sans_graphs"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "DevTools__paper__actions",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            onClick: reloadPage,
                            children: "Reload"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            variant: "transparent",
                            onClick: function() {
                                return toggleShowDevTools();
                            },
                            children: "Close"
                        })
                    ]
                })
            ]
        })
    });
};
DevToolsComponent.propTypes = {};
var DevTools = dynamic_default()((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
    return runtime_default().wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                return _ctx.abrupt("return", DevToolsComponent);
            case 1:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
})), {
    ssr: false
});


/***/ })

}]);